import { EnumService } from "./../../../shared/services/enum.service";
import { AuthService } from "./../../../shared/services/auth.service";
import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { Product } from "src/app/modals/product.model";
import { ProductService } from "src/app/components/shared/services/product.service";
import { ActivatedRoute, NavigationEnd, Params, Router } from "@angular/router";
import { MatDialog } from "@angular/material";
import { CartService } from "src/app/components/shared/services/cart.service";
import { SwiperDirective, SwiperConfigInterface } from "ngx-swiper-wrapper";
import { ProductZoomComponent } from "./product-zoom/product-zoom.component";
import { NgxSpinnerService } from "ngx-spinner";
import { CaroucelRelacionado } from "src/app/modals/caroucel-relacionado";
import { environment } from "src/environments/environment";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ItemsService } from "src/app/services/items.service";
import { constApi } from "src/environments/constApi";
import { ProductDailogGifComponent } from "./product-dailog-gif/product-dailog-gif.component";
import { EcommerceNpService } from "src/app/components/shared/services/ecommerce-np.service";
declare var $: any;

@Component({
  selector: "app-product-details",
  templateUrl: "./product-details.component.html",
  styleUrls: ["./product-details.component.sass"],
})
export class ProductDetailsComponent implements OnInit {
  // getYPosition(e: Event): number {
  //   return (e.target as Element).scrollTop;
  // }

  public config: SwiperConfigInterface = {};

  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();

  @ViewChild("zoomViewer", { static: true }) zoomViewer;
  @ViewChild(SwiperDirective, { static: true }) directiveRef: SwiperDirective;

  public productItem: Product;
  public products: Product[] = [];
  public atributosECOrdenados: any[] = [];

  public image: any;
  public zoomImage: any;

  public stockInicial;

  public counter: number = 1;
  fbFormProductDetail: FormGroup;
  index: number;
  bigProductImageIndex = 0;
  listBannerPub: any;
  idProducto: any;
  productCarroucel: any;
  caroucelRelacionado: CaroucelRelacionado = new CaroucelRelacionado();
  agotado: boolean = false;
  msgDisponibilidad: string = "Disponible";
  ctas: any[] = [];
  gisfArray: any[] = [];
  constructor(
    private route: ActivatedRoute,
    public productsService: ProductService,
    public dialog: MatDialog,
    private router: Router,
    private cartService: CartService,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private enumService: EnumService,
    private fb: FormBuilder,
    private itemService: ItemsService,
    private ecomService: EcommerceNpService
  ) {}

  ngOnInit() {
    this.buildForm();
    if (document.querySelector("mat-sidenav-content") != null)
      document.querySelector("mat-sidenav-content").scrollTop = 0;
    this.idProducto = Number(this.route.snapshot.params["id"]);
    // console.log(this.idProducto)
    this.cargarDatos();
    this.cargarData();
    this.spinner.hide();
  }

  buildForm() {
    this.fbFormProductDetail = this.fb.group({
      cantidad: [1],
    });
  }

  cargarDatos() {
    //this.spinner.show();
    this.productsService
      .getProductsECById(this.idProducto)
      .subscribe((product: any) => {
        //this.spinner.hide();
        if (product.length > 0) {
          //console.log(product)
          let imagen: string =
            product[0].ImagenP == null
              ? "https://novaplaza.pe/assets/img/nodisponible.png"
              : product[0].ImagenP;
          this.productItem = product[0];
          const atributos = Array.isArray(
            this.productItem.itemsEC_Atributos_List
          )
            ? this.productItem.itemsEC_Atributos_List
            : [];
          this.atributosECOrdenados = [
            ...atributos.filter(
              (atributo) =>
                atributo.TipoAtributoEC === "TXT" ||
                atributo.TipoAtributoEC === "TXTICO"
            ),
            ...atributos.filter(
              (atributo) => atributo.TipoAtributoEC === "ICO"
            ),
          ];
          this.productItem.items_Img_List =
            product[0].itemsEC_Img_List.length == 0
              ? product[0].items_Img_List
              : product[0].itemsEC_Img_List;
          this.productItem.ImagenP = imagen;
          if (this.productItem.OtrosEC != "") {
            let otrosEc: any = this.productItem.OtrosEC.split("|");
            let item: any = [];
            if (otrosEc.length > 0) {
              let dataText = [];
              otrosEc[0].split("\n").forEach((x) => {
                if (x.length > 0) {
                  dataText.push(x);
                }
              });
              item.push(dataText);
            }
            if (otrosEc.length > 1) {
              let dataIcon = [];
              otrosEc[1].split("\n").forEach((x) => {
                if (x.length > 0) {
                  dataIcon.push(x);
                }
              });
              item.push(dataIcon);
            }
            this.productItem.OtrosEC = item;
          }
          this.gisfArray = [];
          this.productItem.items_Img_List.forEach((x) => {
            if (x.NombreImg.includes(".gif")) {
              this.gisfArray.push(x);
            }
          });
          this.productItem.items_Img_List =
            this.productItem.items_Img_List.filter(
              (x) => !x.NombreImg.includes(".gif")
            );
          this.stockInicial = this.productItem.SaldoG;
          if (this.productItem.SaldoG == 0) {
            this.msgDisponibilidad = "Agotado";
            this.agotado = true;
          } else {
            this.msgDisponibilidad =
              (this.productItem.PV6 > 0 ? "Por llegar " : "") +
              String(this.productItem.SaldoG) +
              " Unidades";
            this.agotado = false;
          }
          ////console.log(this.productItem.PV2);
          this.loadRelacionados(this.productItem.Codigo);
          this.spinner.hide();
        } else {
          this.productItem = null;
        }
      });

    this.getRelatedProducts();
    this.loadBanner();
  }
  cargarData() {
    let param = [{ clave: "CuentaB", valor: "%" }];
    this.ecomService
      .getParam(environment.apiUrlTeso, constApi.CTASBANCOS, param)
      .subscribe((res: any) => {
        this.ctas = res.body.filter((x) => x.CuentaB != "21503063274012");
        this.ctas.forEach((x) => {
          if (x.SiglasBco == "BCP") {
            x.logo = "assets/img/bcp-logo.png";
          }
          if (x.SiglasBco == "BVL") {
            x.logo = "assets/img/interbank-logo.png";
          }
          if (x.SiglasBco == "BBVA") {
            x.logo = "assets/img/bbva-logo.png";
          }
        });
      });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.config = {
        observer: true,
        slidesPerView: 3,
        spaceBetween: 10,
        keyboard: true,
        navigation: true,
        pagination: false,
        grabCursor: true,
        loop: false,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          480: {
            slidesPerView: 1,
          },
          740: {
            slidesPerView: 2,
          },
          960: {
            slidesPerView: 3,
          },
          1280: {
            slidesPerView: 3,
          },
        },
      };
    }, 2);

    //#region
    let top = document.getElementById("top");
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
    //#endregion
  }

  public openProductDialog(product, bigProductImageIndex) {
    let dialogRef = this.dialog.open(ProductZoomComponent, {
      data: { product, index: bigProductImageIndex },
      panelClass: "product-dialog",
    });
    dialogRef.afterClosed().subscribe((product) => {
      if (product) {
        this.router.navigate(["/products", product.id, product.name]);
      }
    });
  }

  public selectImage(index) {
    this.bigProductImageIndex = index;
  }

  public increment() {
    if (this.productItem.APedido) {
      this.counter = 1;
    } else {
      ////console.log(this.counter);
      ////console.log(this.stockInicial);
      //productItem.SaldoG <= counter && productItem.SaldoG != 0
      this.counter += 1;
      if (Number(this.counter) < Number(this.stockInicial) - 1) {
        // this.msgDisponibilidad = "Disponible";
        this.agotado = false;
      } else if (Number(this.counter) == Number(this.stockInicial) - 1) {
        this.counter = this.stockInicial;
        // this.msgDisponibilidad = "Pocas Unidades";
        this.agotado = false;
      } else if (Number(this.counter) >= Number(this.stockInicial)) {
        this.counter = this.stockInicial;
        // this.msgDisponibilidad = "Agotado";
        this.agotado = true;
      }
    }
    this.fbFormProductDetail.get("cantidad").setValue(this.counter);
  }

  public decrement() {
    if (!this.productItem.APedido) {
      this.counter -= 1;
      if (this.counter == 0) {
        this.counter = 1;
      } else if (Number(this.counter) < Number(this.stockInicial) - 1) {
        // this.msgDisponibilidad = "Disponible";
        this.agotado = false;
      } else if (Number(this.counter) == Number(this.stockInicial) - 1) {
        // this.msgDisponibilidad = "Pocas Unidades";
        this.agotado = false;
      } else if (Number(this.counter) >= Number(this.stockInicial)) {
        // this.msgDisponibilidad = "Agotado";
        this.agotado = true;
      }
    } else {
      this.counter = 1;
    }
    this.fbFormProductDetail.get("cantidad").setValue(this.counter);
  }

  getRelatedProducts() {
    this.productsService.getProducts().subscribe((product: Product[]) => {
      this.products = product;
    });
  }

  // Add to cart
  public addToCart(product: Product, quantity) {
    alert("Muy pronto estara disponible!");
    // this.counter = this.fbFormProductDetail.get("cantidad").value;
    // if (Number(this.counter) > Number(this.stockInicial)) {
    //   this.agotado = true;
    // } else {
    //   this.agotado = false;
    //   if (product.PV6 > 0) {
    //     if (sessionStorage.getItem("tp") == null) {
    //       sessionStorage.setItem("tp", "TA");
    //       product.PVVenta = product.PV6;
    //     } else {
    //       if (sessionStorage.getItem("tp") == "TA") {
    //         product.PVVenta = product.PV6;
    //       } else {
    //         product.PVVenta = product.PV6;
    //       }
    //     }
    //   } else {
    //     if (quantity == 0 || product.SaldoG == 0) return false;

    //     if (sessionStorage.getItem("tp") == null) {
    //       sessionStorage.setItem("tp", "TA");
    //       product.PVVenta = product.PV2;
    //     } else {
    //       if (sessionStorage.getItem("tp") == "TA") {
    //         product.PVVenta = product.PV2;
    //       } else {
    //         product.PVVenta = product.PV3;
    //       }
    //     }
    //   }
    //   this.cartService.addToCart(product, this.counter);
    //   document.getElementById("carritoDialog").click();
    //}
  }

  // Add to cart
  public buyNow(product: Product, quantity) {
    let counter: any = this.fbFormProductDetail.get("cantidad").value;
    if (quantity > 0) this.cartService.addToCart(product, parseInt(counter));
    this.router.navigate(["/pages/checkout"]);
  }

  public onMouseMove(e) {
    if (window.innerWidth >= 1280) {
      var image, offsetX, offsetY, x, y, zoomer;
      image = e.currentTarget;
      offsetX = e.offsetX;
      offsetY = e.offsetY;
      x = (offsetX / image.offsetWidth) * 100;
      y = (offsetY / image.offsetHeight) * 100;
      zoomer = this.zoomViewer.nativeElement.children[0];
      if (zoomer) {
        zoomer.style.backgroundPosition = x + "% " + y + "%";
        zoomer.style.display = "block";
        zoomer.style.height = image.height + "px";
        zoomer.style.width = image.width + "px";
      }
    }
  }

  public onMouseLeave(event) {
    this.zoomViewer.nativeElement.children[0].style.display = "none";
  }

  public openZoomViewer() {
    this.dialog.open(ProductZoomComponent, {
      data: this.zoomImage,
      panelClass: "zoom-dialog",
    });
  }

  public calificarEstrella(id, valoracion) {
    if (this.authService.isLogin()) {
      //this.spinner.show();
      this.productsService.calificaValProm(id, valoracion).subscribe((res) => {
        //this.spinner.hide();
        this.productItem.ValProm = valoracion;
      });
    }
  }

  public loadBanner() {
    this.enumService.getBannerBPB().subscribe((res: any) => {
      this.listBannerPub = res;
      // //////console.log(this.listBannerPub);
    });
  }

  public loadRelacionados(categoria) {
    this.productsService
      .getProductsCategoria(categoria)
      .subscribe((res: any) => {
        //////console.log(res)
        this.caroucelRelacionado.itemsEC_Destacados = [];
        res.forEach((element) => {
          let otrosEc: any = element.OtrosEC.split("|");
          let item: any = [];
          if (otrosEc.length > 0) {
            let dataText = [];
            otrosEc[0].split("\n").forEach((x) => {
              dataText.push(x);
            });
            item.push(dataText);
          }
          if (otrosEc.length > 1) {
            let dataIcon = [];
            otrosEc[1].split("\n").forEach((x) => {
              dataIcon.push(x);
            });
            item.push(dataIcon);
          }
          element.OtrosEC = item;
          this.caroucelRelacionado.itemsEC_Destacados.push({
            idItemEC: element.idItemEC,
            TItemEC: element.TItemEC,
            TItemECNom: element.TItemECNom,
            idItem: element.idItem,
            Marca: element.Marca,
            Codigo: element.Codigo,
            Nro: element.Nro,
            NombreItm: element.NombreItm,
            UniMed: element.UniMed,
            UniMedDeno: element.UniMedDeno,
            CodigoBarras: element.CodigoBarras,
            PV1: element.PV1,
            PV2: element.PV2,
            PV3: element.PV3,
            PV4: element.PV4,
            PV5: element.PV5,
            PV6: element.PV6,
            PorcDscto: element.PorcDscto,
            SaldoG: element.SaldoG,
            APedido: element.APedido,
            ImagenP: element.ImagenP,
            Otros: element.Otros,
            OtrosEc: element.OtrosEc == undefined ? [] : element.OtrosEc,
            ClicCant: element.ClicCant,
            ValCant: element.ValCant,
            ValSum: element.ValSum,
            ValProm: element.ValProm,
            Habilitado: element.Habilitado,
            Mostrar: element.Mostrar,
            OrdenIEC: element.OrdenIEC,
            Filial: element.Filial,
          });
        });
      });
  }

  async clickItem(row) {
    // //console.log(row);
    document.querySelector("mat-sidenav-content").scrollTop = 0;
    this.idProducto = row.idItem;
    this.cargarDatos();
    await this.itemService.sumarClic(row.idItem);
    this.router.navigate(["/home/product", row.idItem]);
  }
  backPage() {
    window.history.back();
  }
  enviarMensajeWsp() {
    const formData = {
      phone: "933288799",
      date:
        "%0ACodigo: " +
        this.productItem.CodigoBarras +
        "%0ANombre Item: " +
        this.productItem.NombreItm +
        "%0AUrl: novaplaza.pe/%23/home/product/" +
        this.productItem.idItem,
    };

    const URL = `https://api.whatsapp.com/send?phone=${formData.phone}&text=Hola busco este Producto,%20${formData.date}%20&source=&data=`;
    window.open(URL, "_blank");
  }
  verGif() {
    this.dialog.open(ProductDailogGifComponent, {
      data: this.gisfArray,
      panelClass: "product-dialog",
    });
  }
}
